import type { OTCDealData } from '@src/types/OTC';
import { CopyCsv, CopyJson, Divider, ShowJson } from '@talos/kyoko';
import type { ICellRendererParams } from 'ag-grid-community';

/**
 * OTC Grid Row Menu Component for hamburger menu
 */
export function OTCGridRowMenu(
  params: ICellRendererParams & {
    onShowJson(data: OTCDealData): void;
  }
) {
  return (
    <>
      <ShowJson {...params} />
      <Divider orientation="horizontal" />
      <CopyJson {...params} />
      <CopyCsv {...params} />
    </>
  );
}
